import {
  OrderStatus as ApiOrderStatus,
  OrderType as ApiOrderType,
} from 'data/types/global';

export type OrderStatusKey = ApiOrderStatus;

export const STATUS = {
  SHCEDULED: {
    key: 'SCHEDULED' as OrderStatusKey,
    caption: 'Scheduled',
  },
  CANCELLED: {
    key: 'CANCELLED' as OrderStatusKey,
    caption: 'Cancelled',
  },
  COMPLETE: {
    key: 'COMPLETE' as OrderStatusKey,
    caption: 'Completed',
  },
  READY: {
    key: 'READY' as OrderStatusKey,
    caption: 'Ready',
  },
  PENDING: {
    key: 'PENDING' as OrderStatusKey,
    caption: 'Pending',
  },
};

export const normalizeOrderStatus = (status: OrderStatusKey) => {
  switch (status) {
    case 'SCHEDULED':
      return STATUS.SHCEDULED;
    case 'CANCELLED':
      return STATUS.CANCELLED;
    case 'COMPLETE':
      return STATUS.COMPLETE;
    case 'READY':
      return STATUS.READY;
    default:
    case 'PENDING':
      return STATUS.PENDING;
  }
};

export const normalizeOrderType = (type: ApiOrderType) => {
  switch (type) {
    case 'EAT_IN':
      return {
        key: type,
        caption: 'Eat In',
        isGroup: true,
      };
    case 'DELIVERY':
      return {
        key: type,
        caption: 'Delivery',
        isGroup: true,
      };
    default:
    case 'PICKUP':
      return {
        key: type,
        caption: 'Pickup',
        isGroup: false,
      };
  }
};

export type OrderStatus = ReturnType<typeof normalizeOrderStatus>;
export type OrderType = ReturnType<typeof normalizeOrderType>;

export type Option = { label: string; value: string; disabled?: boolean };
export type Options = Option[];
